module.exports = __webpack_public_path__ + "static/mobilestrike-dad623546e757c8f3ca6dbd246b31823.jpg";